var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9491 14.2637L10.1782 11.5255L10.2109 11.4927C12.1091 9.37636 13.4618 6.94365 14.2582 4.36909H17.4546V2.18183H9.81818V0H7.63634V2.18183H0V4.35273H12.1854C11.4491 6.45816 10.2981 8.45452 8.72723 10.2C7.71269 9.07092 6.87267 7.84365 6.20724 6.54545H4.02545C4.8218 8.32362 5.91274 10.0036 7.27634 11.52L1.72907 17.0018L3.27273 18.5455L8.72729 13.0909L12.12 16.4836L12.9491 14.2637Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0909 8.72754H16.9091L12 21.8184H14.1818L15.4091 18.5457H20.5909L21.8182 21.8184H24L19.0909 8.72754ZM16.2273 16.3639L18 11.6348L19.7728 16.3639H16.2273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.d59c3b685e500312e6c9bf9b5de3fef3.svg";
export { ForwardRef as ReactComponent };